<template>
  <div>
    <button class="btn normal-btn c" @click="exportExcel" disabled="disabled">
      <img alt="" src="../assets/imgs/export.svg" width="20" height="20">
      导出记录
    </button>
    <table class="slist" id="table-server">
      <thead>
      <th></th>
      <th>域名</th>
      <th>所属账号</th>
      <th>续费价格</th>
      <th></th>
      <th>过期时间</th>
      <th>最后同步</th>
      </thead>
      <tr v-for="(s, i) in server" :key="i" :style="{opacity: s.status == '已停止' || s.status == 'Expired' ? 0.3 : 1}">
        <td width="30" height="20" @mouseenter="$tip(s.website)">
          <div class="c">
            <img v-if="s.website == 'Godaddy'" src="../assets/imgs/godaddy.png" width="15" class="icon-status"/>
            <img v-if="s.website == '阿里云'" src="../assets/imgs/ali.png" width="20" class="icon-status"/>
          </div>
        </td>
        <td width="50">{{ s.domain }}</td>
        <td>
          <p class="sn">{{ s.account }}</p>
        </td>
        <td class="m-hide">
          <p class="sn">{{ toFixed(s.renewalPrice) }}</p>
        </td>
        <td>
          <div class="c nowrap">
            <img v-if="s.status == '运行中'" src="../assets/imgs/play.svg" width="20" class="icon-status"/>
            <img
                v-else-if="s.status == '已停止' || s.status == 'Expired'"
                src="../assets/imgs/stop.svg"
                width="20"
                class="icon-status"
            />
            <img v-else src="../assets/imgs/loading1.svg" width="20" class="icon-status"/>
            {{ s.status }}
          </div>
        </td>
        <td>
          <p class="nowrap">{{ getDay(s.expirationDate) }}</p>
        </td>
        <td>
          <p class="nowrap">{{ getDay(s.lastUpdateTime) }}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import "../assets/styles/setting-m.css";
import "../assets/styles/setting.css";
import util from "../util";
import appConfig from "@/app-config";

export default {
  data() {
    return {
      server: [],
      tipId: null,
      socketNeedReconnect: true
    };
  },
  inject: ["componentSetting"],
  methods: {
    loadData() {
      let self = this;
      this.$get("/domain/list", { username: this.user.name }, (res) => {
        self.server = res;

        self.componentSetting.menus[1].subMenus[1].subTitle = `我的域名（${res.length}）`;
        self.componentSetting.setTitle();
      });
    },
    restart(serverId, i) {
      var self = this;
      this.$get(
          "/sp/user/server/restart",
          {
            serverId: serverId,
          },
          () => {
            self.server[i].status = "停止中";
          }
      );
    },
    getDay(dateStr) {
      return util.friendlyDate1(dateStr);
    },
    toFixed(val) {
      if (val)
        return util.toFiexd(val, "￥");
    },
    exportExcel() {
      util.loadBegin()
      let self = this;
      util.loadJS('https://www.layuicdn.com/layui/layui.js', layuiExprot)

      function layuiExprot() {
        self.$get('/sp/user/server-export-data', { username: self.user.name }, exportServers => {
          let layui = window.layui;
          layui.use('table', () => {
            let table = layui.table;
            let head = ['#', '续费价格', '主机名', '服务商', '地域', 'IP', '服务器ID', '当前状态', '到期', '所属账号']
            let rows = Array.from(exportServers, (item, i) => {
              return [
                i + 1,
                item.xufeiPrice,
                item.serverName,
                item.type,
                item.region,
                item.ip,
                item.serverId,
                item.status,
                new Date(item.expiredTime).Format('yyyy年MM月dd'),
                item.account
              ]
            })
            table.exportFile(head, rows, 'xls');
            util.loadClose()
          })
        })
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    user(newUser) {
      if (newUser) this.loadData();
    },
  },
  mounted() {
    this.loadData();
    window.$settingServer = this;

    // websocket
    const self = this;

    // websocket 接收服务器状态更新
    const url = `${appConfig.socketUrl}${self.user.name}`
    buildSocket()

    function buildSocket() {
      console.log("连接到websocket", url);
      let socket = (self.socket = new WebSocket(url));
      socket.onmessage = (res) => {
        let data = [];
        if (res.data) {
          data = res.data.replace(/ \(From Server，Session ID=.*\)/g, "");
          data = JSON.parse(data);
        }
        console.log("接受: ", data.length);
        data.forEach((item) => {
          for (let i = 0; i < self.server.length; i++) {
            let s = self.server[i];
            if (s.serverId === item.serverId) {
              self.server[i].account = item.account;
              self.server[i].expiredTime = item.expiredTime;
              self.server[i].serverName = item.serverName;
              self.server[i].status = item.status;
              self.server[i].type = item.type;
              self.server[i].xufeiPrice = item.xufeiPrice;
            }
          }
        });
        self.$forceUpdate();
      }
      let keepaliveIntervalId = setInterval(() => {
        self.socket.send(1)
      }, 10000)
      socket.onclose = () => {
        console.log("socket断开，重新连接: ", self.socketNeedReconnect);
        clearInterval(keepaliveIntervalId)
        if (self.socketNeedReconnect)
          setTimeout(buildSocket, 2000)
      }
    }
  },
  destroyed() {
    this.socketNeedReconnect = false;
    this.socket.close()
  }
};
</script>
<style scoped>
.btn.normal-btn {
  margin-bottom: 10px;
}

.slist td {
  text-align: left;
}
</style>
